import { eMode } from "../../../content/enum";
import {
  IDmMucHoTroNhaNuoc,
  IDmMucHoTroNhaNuocSelectRequest,
} from "../../../model/respone/category/IDmMucHoTroNhaNuoc";
import { IDmMucHoTroNhaNuocActionTypes } from "../../action-types/category/IDmMucHoTroNhaNuocActions";
import { IDmMucHoTroNhaNuocReducer } from "../../reducer-model/category/IDmMucHoTroNhaNuocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDmMucHoTroNhaNuocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mucHoTroNhaNuocs: [],
  mode: eMode.xem,
  isShowCopyModal: false,
  requestCopy: {},
  expandedKeys: [],
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_he: 0,
    khoa_hoc: 0,
  } as IDmMucHoTroNhaNuocSelectRequest,
};

export const mucHoTroNhaNuocReducer = (
  state: IDmMucHoTroNhaNuocReducer = iniState,
  action: IDmMucHoTroNhaNuocActionTypes,
): IDmMucHoTroNhaNuocReducer => {
  switch (action.type) {
    case "MUC_HO_TRO_NHA_NUOC_UPDATE_STATUS":
      return { ...state, status: action.payload };
    case "MUC_HO_TRO_NHA_NUOC_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "MUC_HO_TRO_NHA_NUOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucHoTroNhaNuocs: action.payload,
      };
    case "MUC_HO_TRO_NHA_NUOC_LOAD_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "MUC_HO_TRO_NHA_NUOC_SAVE_MULTIPLE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "MUC_HO_TRO_NHA_NUOC_SAVE_MULTIPLE_SUCCESS": {
      // Lưới TỰ LƯU mỗi lần rời ô, nên KHÔNG nạp lại và KHÔNG thoát chế độ Sửa: nạp lại sẽ
      // giật lưới và xóa số đang gõ dở, còn thoát chế độ Sửa thì gõ được đúng một ô.
      // ★ Nhưng PHẢI gộp các dòng vừa lưu vào danh sách: trước đây chỉ lưới giữ số vừa gõ (khóa
      //   theo id nút, mà id nút đổi theo kiểu xem) ⇒ đổi kiểu xem / rời màn rồi quay lại là hiện
      //   lại số CŨ dù máy chủ đã lưu số mới. Gộp theo đúng luật của thủ tục _Saves: cả hai ô <= 0
      //   là xóa phạm vi đó, còn lại là thêm / ghi đè cả hai cột.
      const khoa = (r: IDmMucHoTroNhaNuoc) =>
        `${r.hoc_ky}|${r.nam_hoc ?? ""}|${r.id_he}|${r.khoa_hoc}|${r.id_khoi_nganh}|${r.id_nganh}|${r.id_chuyen_nganh}`;
      const vuaLuu = new Map(action.payload.map((r) => [khoa(r), r]));
      const giuLai = (state.mucHoTroNhaNuocs ?? []).filter(
        (r) => !vuaLuu.has(khoa(r)),
      );
      // Chỉ nhận dòng của đúng kỳ đang xem: lưu xong mà người dùng đã đổi kỳ thì bỏ qua.
      const themVao = Array.from(vuaLuu.values()).filter(
        (r) =>
          r.hoc_ky === state.request.hoc_ky &&
          (r.nam_hoc ?? "") === (state.request.nam_hoc ?? "") &&
          (r.so_tien > 0 || (r.so_tien_toi_da_1_tin_chi ?? 0) > 0),
      );
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucHoTroNhaNuocs: [...giuLai, ...themVao],
      };
    }
    case "MUC_HO_TRO_NHA_NUOC_SAVE_MULTIPLE_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "MUC_HO_TRO_NHA_NUOC_SHOWHIDE_COPY_MODAL":
      return {
        ...state,
        isShowCopyModal: action.payload,
        // Đóng modal thì xóa luôn lựa chọn nguồn, lần sau mở ra không dính số cũ.
        requestCopy: action.payload ? state.requestCopy : {},
      };
    case "MUC_HO_TRO_NHA_NUOC_COPY_CHANGE_REQUEST":
      return { ...state, requestCopy: { ...state.requestCopy, ...action.payload } };
    case "MUC_HO_TRO_NHA_NUOC_COPY_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "MUC_HO_TRO_NHA_NUOC_COPY_SUCCESS":
      // Chép xong PHẢI nạp lại: dữ liệu kỳ đang xem vừa bị ghi đè.
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowCopyModal: false,
        requestCopy: {},
      };
    case "MUC_HO_TRO_NHA_NUOC_COPY_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "MUC_HO_TRO_NHA_NUOC_CHANGE_REQUEST":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: { ...state.request, ...action.payload },
      };
    case "MUC_HO_TRO_NHA_NUOC_CHANGE_MODE":
      return { ...state, mode: action.payload };
    case "MUC_HO_TRO_NHA_NUOC_SET_EXPANDED_KEYS":
      return { ...state, expandedKeys: action.payload };
    default:
      return state;
  }
};
